import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const AncillaryBusinesses = (props) => {
	const ancillaryBusinesses = props.data.ancillary_businesses;

	if (!_.isArray(ancillaryBusinesses) || _.isEmpty(ancillaryBusinesses)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(ancillaryBusinesses, ({ ab_ancillary_business_name: ancillaryBusinessName }) => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{ancillaryBusinessName}
				</li>
			))}
		</ul>
	);
};

AncillaryBusinesses.propTypes = {
	data: PropTypes.object.isRequired,
};

export default AncillaryBusinesses;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/ancillary-businesses.js